module.exports = __webpack_public_path__ + "img/20.d3e50157.png";